module.exports = __webpack_public_path__ + "ea21f6b8c8bbb196687e91b31ad81f1f.pdf";